import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';
import { UIPageStore } from 'stores/ui-page-store';

import { MAX_RATING } from 'components/infosite/property-details/bar-ratings';
import { ReviewsDialogLayer } from './reviews-dialog-layer';

const LinkTracked = ClickTracker(Link);

export interface ReviewsProps {
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  reviews?: any;
  uiPage?: UIPageStore;
  currentHotel?: CurrentHotelStore;
}

export type LocalizedReviewsProps = ReviewsProps & LocalizedComponentProps;

export interface ReviewsState {
  initialized: boolean;
}

@withLocalization
@inject('routeStore', 'analytics', 'uiPage', 'currentHotel')
@observer
export class Reviews extends React.Component<LocalizedReviewsProps, ReviewsState> {
  private reviewsAction;
  private reviewsWrapper;

  public constructor(props) {
    super(props);

    this.state = {
      initialized: false
    };

    this.onReviewsDialogClosed = this.onReviewsDialogClosed.bind(this);
  }

  public componentDidMount() {
    this.setState({ initialized: true });
  }

  public render() {
    const { currentHotel, reviews, routeStore } = this.props;
    const { searchCriteria } = currentHotel;
    const { initialized } = this.state;

    const countClassNames = 'uitk-cell uitk-type-right all-cell-shrink';

    const ra = reviewsAction => {
      this.reviewsAction = reviewsAction;
    };
    const rw = reviewsWrapper => {
      this.reviewsWrapper = reviewsWrapper;
    };
    const schema = 'https://schema.org/AggregateRating';

    return (
      <div className="uitk-grid all-cell-1-2" ref={rw} itemProp="aggregateRating" itemScope={true} itemType={schema}>
        <span className="uitk-type-300 uitk-cell all-t-padding-two all-cell-fill" data-stid="content-hotel-reviewsummary">
          {reviews && reviews.localizedOverallRating && (
            <React.Fragment>
              <meta itemProp="ratingValue" content={reviews.localizedOverallRating} />
              <span className="reviews-summary__rating uitk-type-bold uitk-type-300">
                <span className="reviews-summary__rating-value">{`${reviews.localizedOverallRating} / ${MAX_RATING}`}</span>
              </span>
              {reviews.superlative && (
                <React.Fragment>
                  <meta itemProp="description" content={reviews.superlative} />
                  <span className="reviews-summary__superlative pwa-theme--grey-700 all-x-padding-one">{reviews.superlative}</span>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </span>
        {reviews && reviews.localizedCountWithLabel && (
          <>
            {initialized && (
              <div className={countClassNames}>
                <UitkLink>
                  <LinkTracked
                    linkName="Display detailed reviews"
                    disabled={!initialized || null}
                    rfrr="UGC.ViewAllResults"
                    events="event419=10"
                    innerRef={ra}
                    to={{
                      pathname: routeStore.pathname,
                      search: this.props.routeStore.mergeQueryString(routeStore.search, { pwaDialog: 'reviews' })
                    }}
                  >
                    <meta itemProp="reviewCount" content={reviews.count} />
                    {reviews.localizedCountWithLabel}
                    <UitkIcon name="chevron_right" />
                  </LinkTracked>
                </UitkLink>
              </div>
            )}
            {!initialized && (
              <div className={countClassNames}>
                <span className="uitk-link uitk-link-layout-default uitk-type-300 is-disabled">
                  <meta itemProp="reviewCount" content={reviews.count} />
                  {reviews.localizedCountWithLabel}
                </span>
              </div>
            )}
          </>
        )}
        <QueryRoute query={{ pwaDialog: 'reviews' }}>
          <ReviewsDialogLayer searchCriteria={searchCriteria} onReviewsDialogClosed={this.onReviewsDialogClosed} />
        </QueryRoute>
      </div>
    );
  }

  private onReviewsDialogClosed() {
    // Close the reviews dialog
    this.props.routeStore.goBack();

    if (this.reviewsAction && typeof this.reviewsAction.focus === 'function') {
      this.reviewsAction.focus();

      return;
    }

    this.reviewsWrapper.focus();
  }
}
